export default "__VITE_PUBLIC_ASSET__9d275b26__"